module.exports = __webpack_public_path__ + "media/img/use-ico-9-68df51856ec50bef9b6b79469591546b.svg";